import { Dispatch } from 'redux';
import API from 'services/api';
import showErrorAlert, { parseError } from 'services/errorHandler';
import {
  VIEW_PIN_FAIL,
  VIEW_PIN_SET_TIME_OUT,
  VIEW_PIN_START,
  VIEW_PIN_SUCCESS
} from 'redux/constants/issuing/viewPin';
import { SUCCESS_CODE } from 'consts';
import { VIEW_PIN_SHOW_PIN } from 'redux/constants';
import sessionService from 'services/session';
import { resetReduxActivatePageState } from 'redux/actions/issuing/reset';

interface IViewPinProps {
  token: string;
  cardId: string;
}

const viewPINStart = () => ({
  type: VIEW_PIN_START
});

const viewPINSuccess = (data: string) => ({
  type: VIEW_PIN_SUCCESS,
  payload: { data }
});

const viewPINFail = (error: string) => ({
  type: VIEW_PIN_FAIL,
  payload: { error }
});

export const setShowPIN = (show: boolean) => ({
  type: VIEW_PIN_SHOW_PIN,
  payload: { data: show }
});

export const viewPinSetTimeOut = (closeIframe: boolean) => ({
  type: VIEW_PIN_SET_TIME_OUT,
  payload: { data: closeIframe }
});

export const viewPin =
  ({ token, cardId }: IViewPinProps) =>
    async (dispatch: Dispatch<any>) => {
      dispatch(viewPINStart());

      try {
        const apiData = { card_id: cardId };
        const response = await API.makeApiCall({
          method: 'get',
          url: `hosted/issuing/view_pin/${token}`,
          data: apiData,
          pageToken: token
        });

        const {
          status: { status },
          data
        } = response.data || {};
        if (status === SUCCESS_CODE) {
          dispatch(viewPINSuccess(data));
        } else {
          showErrorAlert({ error: 'ERROR_VIEW_PIN' });
        }
      } catch (error) {
        const { status } = parseError(error);
        const unAuthorized = sessionService.handleUnauthorizedError(error, token);
        if (unAuthorized) {
          return dispatch(resetReduxActivatePageState());
        }
        const { error_code: errorCode } = status || {};
        dispatch(viewPINFail(errorCode));
        showErrorAlert({ error: 'ERROR_VIEW_PIN' });
      }
    };
